import { Chip } from "@legal-500/legal500-design-system";
import type { AwardStatus } from "../../../api/awards.types.js";
import styles from "./AwardsCells.module.css";

/**
 * A local chip rather than a shared badge, which is the dominant pattern in this
 * app (~28 local status implementations against one consumer of the shared
 * `components/StatusBadge`). Neither shared component knows this vocabulary:
 * `components/StatusBadge` handles draft/published only and greys anything else,
 * and `components/ResearchCms/StatusBadge` speaks edition/review statuses, so
 * "winner" would fall through its `humaniseStatus` default and land in the same
 * grey pill as "shortlisted". A silent grey is exactly the failure mode worth
 * avoiding on the column that says whether an award was won.
 */
const AWARD_STATUS_LABELS: Record<AwardStatus, string> = {
  winner: "Winner",
  shortlisted: "Shortlisted",
  highly_commended: "Highly Commended",
};

const AWARD_STATUS_CLASS_NAMES: Record<AwardStatus, string> = {
  winner: styles.awardStatusWinner,
  shortlisted: styles.awardStatusShortlisted,
  highly_commended: styles.awardStatusHighlyCommended,
};

type AwardStatusChipProps = {
  status: AwardStatus;
};

export function AwardStatusChip({ status }: AwardStatusChipProps) {
  return (
    <Chip size="small" variant="filled" className={AWARD_STATUS_CLASS_NAMES[status]}>
      {AWARD_STATUS_LABELS[status]}
    </Chip>
  );
}
